import { useQuery } from '@tanstack/react-query';
import { fetchLastMessageIndex, lastMessageIndexQueryKey } from 'app/services/twilio/lastMessageIndex';

export default function useLastMessageIndex() {
  const { data } = useQuery<number>({
    queryKey: lastMessageIndexQueryKey,
    queryFn: fetchLastMessageIndex,
  });

  return data ?? 0;
}
